import React from 'react';
import PropTypes from 'prop-types';

import Card from './components/Card';

const CardsSkeleton = (props) => {
  const { count } = props;

  return (
    <div className="card-container">
      {[...Array(count)].map((_e, i) => (
        <Card key={i} />
      ))}
    </div>
  );
};

export default CardsSkeleton;

CardsSkeleton.propTypes = {
  count: PropTypes.number.isRequired,
};
